<script>

import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  props: {
    answers: {
      type: Object,
      default: null
    }
  },
  data: ()=> ({
    config : {
      responsive: true,
      legend : {
        display: false
      },
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // Only show whole numbers
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
          gridLines: {
            display: false,
            drawBorder: false
          }
        }],
        yAxes: [{
          gridLines: {
            display: false,
            drawBorder: false
          }
        }]
      }
    }

  }),
  computed: {
  },
  mounted () {
    
    const data = {
      labels: _.keys(this.answers),
      datasets: [
        {
          label: 'Result',
          backgroundColor: '#f87979',
          data: _.values(this.answers),
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)'
          ],
          borderWidth: 0
        }
      ]
    };

    this.renderChart(data, this.config);
  }
}
</script>